import { evaluateConditionalSkillTargeting } from 'api/targeting'
import store from 'config/store'
import { omit } from 'ramda'
import { ConditionalSkillConditionSetsToEvaluate, ConditionalSkillEvaluationPayload, TargetingCondition } from 'types/targeting'
import { log } from 'utils'
import { broadcast } from 'utils/message'

import { evaluateConditionalSkillTargetingConditions } from './evaluation'
import { getTargetingEvaluationContext } from './utils'

const omitPropertyFromConditionSetList = (conditionSetList: TargetingCondition[][], propertyKey: string) => {
  return conditionSetList
    .map(conditionSet => conditionSet
        .map(condition => omit([propertyKey], condition)))
}

export const generateTargetingContext = async () => {
  const { embed, session, targeting = {} } = store.getState()

  const { data: hostWindow = {} } = await broadcast({
    topic: 'get-window-context'
  })

  const { data: hostCookies = {} } = await broadcast({
    topic: 'get-host-cookies'
  })

  const { data: referrer = '' } = await broadcast({
    topic: 'get-host-referrer',
  })

  const { data: scrollableHeight } = await broadcast({
    topic: 'get-scrollable-height',
  })

  const context = {
    _window: hostWindow,
    visitInformation: session.visitInformation,
    cookies: hostCookies,
    geo: session.geo,
    embed,
    referrer,
    scrollableHeight,
    hasExitIntent: targeting.hasExitIntent
  }

  return Promise.resolve(context)
}

export const evaluateTargetingForConditionalSets = async(conditionalSetsList: ConditionalSkillConditionSetsToEvaluate[] = []) : Promise<ConditionalSkillEvaluationPayload> => {
  const conditionSetPayload = conditionalSetsList.map((conditionalSet) => {

    // wfallows 12-23-20: This is a stopgap for WID-732 as "mapValue" has trouble deserializing on the backend
    const scrubbedConditionSets = omitPropertyFromConditionSetList(conditionalSet.conditionSets, 'mapValue')

    return {
      key: `${conditionalSet.outputKey}-${conditionalSet.label}`,
      priority: conditionalSet.priority,
      conditionSets: scrubbedConditionSets
    }
  })

  const { embed } = store.getState()
  const targetingEvaluationContext = getTargetingEvaluationContext()

  try {
    const { data } = await evaluateConditionalSkillTargeting(embed.id, {
      clientSideContext: targetingEvaluationContext,
      conditionGroups: conditionSetPayload
    })

    return await evaluateConditionalSkillTargetingConditions(data)
  } catch (err) {
    log({ data: [`Failed to evaluate conditional skill`, err]})
  }
}
